import { Component, Input, OnInit } from '@angular/core';
import { ResellerInfoModel } from '../../../../../management/account/models/profile/reellerInfoModel';

@Component({
  selector: 'app-reseller-status',
  templateUrl: './reseller-status.component.html',
  styleUrls: ['./reseller-status.component.scss']
})
export class ResellerStatusComponent implements OnInit {
  @Input('sellerInfo') sellerInfo: ResellerInfoModel;
  constructor() { }

  ngOnInit() {
  }

}
